import React, { useEffect, useMemo, useRef, useState } from "react";
import Popup from "./Popup";
import {
  caseStatus,
  fileNameType,
  requestFormStatus,
  requestFormStatusColor,
  requestFormStatusLabel,
} from "app/constants";
import moment from "moment";
import { commonServices } from "app/services/api";
import messages from "../../../../services/api/messages";
import { toast } from "react-toastify";
import PrimaryBtn from "../../../UI/Button/PrimaryBtn";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { useFormik } from "formik";
import { projectServices } from "../../../../services/api";
import InputText from "../../../UI/Form/Input/InputText";
import { formatIndex, getBaseName } from "../../../../utils";

function RequestFromCell(props) {
  const {
    width,
    requestFormStatusValue,
    requestFormInfo,
    caseInfo,
    highlight = false,
    setCaseInfo,
    setDownloading,
  } = props;
  const [anchor, setAnchor] = useState(null);
  const ref = useRef();

  useEffect(() => {
    if (highlight) {
      ref?.current?.scrollIntoView({ block: "nearest", behavior: "smooth" });
    }
  }, [highlight]);

  const [openModal, setOpenModal] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  const isRejected = requestFormStatusValue === requestFormStatus.rejected;

  const disabledChangeStatus = useMemo(() => {
    return (
      caseInfo?.caseStatus === caseStatus.completed ||
      caseInfo?.caseStatus === caseStatus.lost
    );
  }, [caseInfo]);

  const handleLeftClickRequestFrom = () => {
    if (requestFormInfo?.fileInfo) {
      const files = Array.isArray(requestFormInfo.fileInfo) ? requestFormInfo.fileInfo : [requestFormInfo.fileInfo];

      setDownloading(true);

      const caseId = caseInfo?.caseId || "";
      const fileType = fileNameType["requestForm"];
      const customerName = caseInfo?.customer?.companyNameKanji || "";
      const timeStamp = moment().format("YYYYMMDDHHmmss");

      Promise.all(
        files.map((file, index) =>
          new Promise((resolve) => {
            setTimeout(() => {
              const name = file.fileName ? getBaseName(file.fileName) : `${fileType}_${caseId}_${customerName}_${formatIndex(index + 1)}_${timeStamp}`;

              commonServices
                .downloadPDFWithFileId(
                  file._id,
                  name
                )
                .finally(() => resolve());
            }, index * 500);
          })
        )
      ).finally(() => setDownloading(false));
    }
  };

  const handleRightClickRequestFrom = (e) => {
    if (disabledChangeStatus) return;
    e.preventDefault();
    if (isRejected) {
      setAnchor(e.target);
    }
  };

  const showModal = () => {
    setOpenModal(true);
    setAnchor(null);
  };

  const handleUpdateRequestFromStatus = async (values) => {
    if (isUpdating) return;
    setIsUpdating(true);
    try {
      const res = await projectServices.updateRequestFromStatus({
        id: caseInfo._id,
        statusType: "requestFormStatus",
        value: requestFormStatus.confirmed,
        comment: values.comment,
      });
      const data = res?.data?.result;
      setAnchor(null);
      setOpenModal(false);
      setCaseInfo({
        ...caseInfo,
        requestFormStatus: data?.requestFormStatus,
      });
    } catch (error) {
      toast.error(messages.callApiFail);
    } finally {
      setIsUpdating(false);
    }
  };

  const closeModal = () => {
    setFieldValue("comment", "");
    setOpenModal(false);
    setAnchor(null);
  };

  const { handleSubmit, errors, values, setFieldValue, touched, handleBlur } =
    useFormik({
      initialValues: {
        comment: "",
      },
      onSubmit: handleUpdateRequestFromStatus,
      enableReinitialize: true,
    });

  return (
    <>
      <div
        ref={ref}
        className={`h-full border border-[#B3B3B3] px-2 py-4 shrink-0 ${
          highlight && "bg-yellow-100"
        }`}
        style={{
          width: width,
        }}
      >
        <p className="text-sm leading-[18px] tracking-[.2em] truncate text-center">
          <button
            style={{
              color: requestFormStatusColor[requestFormStatusValue],
              cursor: "pointer",
            }}
            onClick={handleLeftClickRequestFrom}
            onContextMenu={handleRightClickRequestFrom}
          >
            {requestFormStatusLabel[requestFormStatusValue]}
          </button>
        </p>
      </div>

      <Popup
        id={`request-form-${requestFormInfo?._id}`}
        anchor={anchor}
        open={Boolean(anchor)}
      >
        <div className="flex gap-2">
          <PrimaryBtn text="再対応依頼" onClick={showModal} />
          <PrimaryBtn text="戻る" onClick={() => setAnchor(null)} />
        </div>
      </Popup>

      <Dialog open={openModal} onClose={() => setOpenModal(false)}>
        <DialogContent>
          <div className="mb-4">再対応依頼 コメント</div>
          <InputText
            name="comment"
            value={values.comment}
            onChange={(value) => setFieldValue("comment", value)}
            handleBlur={handleBlur}
            errors={errors.comment}
            touched={touched.comment}
          />
        </DialogContent>

        <DialogActions>
          <PrimaryBtn text={"キャンセル"} onClick={closeModal} />
          <PrimaryBtn text={"送信"} onClick={handleSubmit} />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default RequestFromCell;
